import { render, staticRenderFns } from "./FaqEditor.vue?vue&type=template&id=7841bd19"
import script from "./FaqEditor.vue?vue&type=script&lang=js"
export * from "./FaqEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports